import React from "react";
import { ShieldCheck, AlertTriangle } from "lucide-react";

function MfaSection({ mfaEnabled, onMfaToggle, hasCustomLoginPage, isUpdating, t }) {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <ShieldCheck className="w-5 h-5 text-gray-600" />
                {t("appPreview.mfa") || "Multi-Factor Authentication"}
            </h2>

            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
                <div className="flex-1">
                    <h3 className="text-sm font-medium text-gray-900">
                        {t("appPreview.mfaToggle") || "Require Email MFA"}
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                        {mfaEnabled
                            ? t("appPreview.mfaEnabledDescription") ||
                              "Users must verify a code sent to their email after login"
                            : t("appPreview.mfaDisabledDescription") ||
                              "No additional verification required after login"}
                    </p>
                </div>
                <button
                    onClick={onMfaToggle}
                    disabled={isUpdating}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                        mfaEnabled ? "bg-blue-600" : "bg-gray-300"
                    } ${isUpdating ? "opacity-50 cursor-not-allowed" : ""}`}
                >
                    <span
                        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                            mfaEnabled ? "translate-x-6" : "translate-x-1"
                        }`}
                    />
                </button>
            </div>

            {mfaEnabled && hasCustomLoginPage && (
                <div className="mt-3 flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                    <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                    <p className="text-sm text-amber-800">
                        {t("appPreview.mfaCustomLoginWarning") ||
                            "You have a custom login page. Ask the AI to add MFA verification to your login page so users can complete the email code step."}
                    </p>
                </div>
            )}
        </div>
    );
}

export default MfaSection;
